__webpack_require__.p = "/vocabulary/";